import CryptoJS from 'crypto-js'

const LOADED_STATUS_ID = '20';

export const validateQR = (data, key) => {
  if (data && data.data && data.data.value && data.signature) {
    // if the data has data value and signature
    const signature = CryptoJS.HmacSHA256(JSON.stringify({value: data.data.value}), key).toString(CryptoJS.enc.Hex);
    if (signature.toLowerCase() === data.signature.toLowerCase()) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export const isOrderLoaded = order => Boolean(order) && order.status_id === LOADED_STATUS_ID;

export const areTripOrdersLoaded = trip => (
  Boolean(trip && trip.orders && trip.orders.length) && trip.orders.every(isOrderLoaded)
);
